<template>
    <div class="container">
        <div class="handle-box">
            <el-cascader
                v-if="departmentTree.length > 0"
                class="mr10 w10rem"
                placeholder="按部门查找"
                :props="{ checkStrictly: true }"
                :options="departmentTree"
                filterable
                clearable
                :show-all-levels="false"
                @change="handleCascader"
            ></el-cascader>
            <el-select
                v-model="query.user_id"
                filterable
                multiple
                collapse-tags
                clearable
                placeholder="选择销售"
                class="handle-select mr10 w7rem"
                style="width:9rem;"
            >
                <el-option
                    v-for="(row,index) in staffList"
                    :key="index"
                    :label="row.realname"
                    :value="row.id"
                ></el-option>
            </el-select>
            <el-date-picker
                class="daterange mr10"
                v-model="query.range"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
            ></el-date-picker>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            <el-button type="primary" icon="el-icon-download" @click="exportFile">导出</el-button>
        </div>

        <el-table
            id="out-table"
            :data="tableData"
            :height="height"
            border
            class="table"
            ref="multipleTable"
            header-cell-class-name="table-header"
            :default-sort="{prop:'sign_date'}"
            v-loading="loading"
        >
            <el-table-column type="index" width="60" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column
                prop="create_time"
                label="推荐时间"
                align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column prop="staff1" label="推荐客服" width="140" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="staff2" label="接收人员" width="140" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="news_types" label="信息类型" width="140" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="mobile" label="手机号码" width="140" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="realname" label="客户姓名" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="source_text" label="渠道" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column
                prop="member_create_time"
                label="创建时间"
                align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="active_status"
                label="回访状态"
                align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column prop="level" label="重要程度" width="80" align="center"></el-table-column>
            <el-table-column prop="city" label="城市" width="80" :show-overflow-tooltip="true"></el-table-column>
        </el-table>

        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[10, 16, 30, 50, 100]"
                :page-size="limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import './css/common.css';
import fileSaver from 'file-saver';
import xlsx from 'xlsx';

export default {
    name: 'basetable',
    data() {
        return {
            loading: false,

            sumFields: ['totals', 'wedding_totals'],
            height: 660,
            departmentTree: [],
            tableData: [],
            query: {
                department_id: '',
                user_id: '',
                source_id: '',
                hotel_id: '',
                company_id: '',
                cooperation_mode: '',
                date_type: '',
                keyword: '',
                range: []
            },
            pagination: {
                page: 1,
                limit: 16,
                total: 0
            },
            page: 1,
            limit: 16,
            total: 0,
            companyList: [],
            sourceList: [],
            hotelList: [],
            staffList: [],
            cooperationModeList: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    created() {
        this.height = window.innerHeight * 0.75;

        this.getData();

        // 获取部门树
        this.getDepartmentTree();

        // 获取picker
        this.getPicker();
    },
    methods: {
        getData() {
            let that = this;
            let url = '/api/statistics.convert/recommend';
            let query = that.query;
            query['pagination'] = this.pagination;
            that.loading = true;
            this.$post(url, query).then(function(response) {
                let result = response.data;
                that.tableData = result.list;
                that.pagination = result.pagination;
                that.page = result.pagination.page;
                that.limit = result.pagination.limit;
                that.total = result.pagination.total;
                that.loading = false;
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.getData();
        },
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.limit = val;
            this.getData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.page = val;
            this.getData();
        },
        // 获取部门树
        getDepartmentTree() {
            let url = '/api/ucenter.department/getDepartmentTree';
            let that = this;
            this.$post(url, {}).then(function(response) {
                that.departmentTree = response.data.tree;
            });
        },
        // 获取Picker
        getPicker() {
            let url = '/api/statistics.picker/items';
            let that = this;
            this.$post(url, {}).then(function(response) {
                that.companyList = response.data.companyList;
                that.cooperationModeList = response.data.cooperationModeList;
                that.sourceList = response.data.sourceList;
                that.hotelList = response.data.hotelList;
            });
        },
        handleCascader(e) {
            let last = e.length - 1;
            this.query.department_id = e[last];
            let that = this;
            let url = '/api/ucenter.user/getDepartmentUserList';
            let query = { id: e[last] };
            // 添加或编辑客资信息
            that.$post(url, query).then(function(response) {
                if (response.code != '200') {
                    that.$message.error(response.msg);
                } else {
                    that.staffList = response.data.list;
                }
            });
        },
        exportFile() {
            let that = this;
            let url = '/api/statistics.convert/downloadRecommend';
            let query = that.query;
            this.$post(url, query, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded' //请求的数据类型为form data格式
                },
                responseType: 'blob' //设置响应的数据类型为一个包含二进制数据的 Blob 对象，必须设置！！！
            }).then(function(res) {
                let blob = new Blob([res], { type: 'application/vnd.ms-excel,charset=utf-8' });
                let url = window.URL.createObjectURL(blob); //创建下载链接
                let link = document.createElement('a');
                link.download = 'user.csv'; //下载后的文件名
                link.href = url;
                link.click();
            });
        },
    }
};
</script>
